import {Component} from '@angular/core';

@Component({
   selector: 'app-main-site-flow',
   templateUrl: './main-site-flow.component.html',
   styleUrls: ['./main-site-flow.component.css']
})
export class MainSiteFlowComponent {

   constructor() {
      // This is intentional.
   }

}
